import Vue from 'vue';
import DatetimePicker from 'vuetify-datetime-picker';

// DatetimePicker
Vue.use(DatetimePicker);
